import { FC } from "react";
// 方法
import getFormItem from '../../hook/getFormItem';
import { formatFormItemName, formatRowKey } from "../../util";
// 常量
import { ChildrenTableCellProps } from "../../interface";

const ChildrenTableCell: FC<ChildrenTableCellProps> = props => {
  const { editable, form, record, rowIndex, name = '', formItemType, simpleFormItemProps, ...restProps } = props;
  const formatKey = formatRowKey(record?.key);

  return editable ? (
    <td {...restProps}>
      {getFormItem(record, { ...simpleFormItemProps, formItemType, rowIndex, form, name: formatFormItemName(name, formatKey.mainKey as string, formatKey.childrenKey), })}
    </td>
  ) : (
    <td {...restProps} />
  );
};

export default ChildrenTableCell;
